var _defs, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarvel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "marvel",
    className: "feature__background",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "marvelpattern",
    className: "tile1",
    patternUnits: "userSpaceOnUse",
    height: 200,
    width: 200,
    y: 0,
    x: 0,
    patternTransform: "scale(0.5) rotate(-10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#980a2a",
    d: "M51.8,10.1C51.7,10.1,51.7,10.1,51.8,10.1l0,11.8c0.5,0,1.1-0.1,1.6-0.4c1.6-0.8,2.9-2.6,2.9-5.6         C56.2,10.2,52.3,10.1,51.8,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#980a2a",
    d: "M0,0v43.9h109V0H0z M92.2,25.3h-6v8.4h6v6.6H79.7V7l-5.3,33.4l-7.7,0c0,0-4-23.6-4-23.7v0         c0.6,3.8-1.8,7.8-3.9,9.4L63,40.3h0h0l0,0h0h-6.5h0l-3.2-12.2l-1.5,0.2v12h0h0v0h0l-12.6,0l-0.8-5.7h-5.2l-0.8,5.7H19.6V22.6         l-3,17.8H13l-3-17.8v17.8H3.4V3.5h8.4l3,19l3-19h8.4l0,33.9l5.1-33.9l8.8,0l4.9,32.7l0-32.7c0,0,6.7,0,6.7,0c6.1,0,8.8,4.5,9.6,6         l-0.8-6h6.7l3,22.4l3.1-22.4h18.7v6.7h-6v8.3h6V25.3z M105.6,40.3H93.4V3.5h6.6v30.2h5.7V40.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#980a2a",
    points: "33.9,28.8 37.7,28.8 35.8,13.1 "
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "marvelpattern2",
    className: "tile1",
    patternUnits: "userSpaceOnUse",
    height: 200,
    width: 200,
    y: 100,
    x: 100,
    patternTransform: "scale(0.5) rotate(-10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#980a2a",
    d: "M51.8,10.1C51.7,10.1,51.7,10.1,51.8,10.1l0,11.8c0.5,0,1.1-0.1,1.6-0.4c1.6-0.8,2.9-2.6,2.9-5.6         C56.2,10.2,52.3,10.1,51.8,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#980a2a",
    d: "M0,0v43.9h109V0H0z M92.2,25.3h-6v8.4h6v6.6H79.7V7l-5.3,33.4l-7.7,0c0,0-4-23.6-4-23.7v0         c0.6,3.8-1.8,7.8-3.9,9.4L63,40.3h0h0l0,0h0h-6.5h0l-3.2-12.2l-1.5,0.2v12h0h0v0h0l-12.6,0l-0.8-5.7h-5.2l-0.8,5.7H19.6V22.6         l-3,17.8H13l-3-17.8v17.8H3.4V3.5h8.4l3,19l3-19h8.4l0,33.9l5.1-33.9l8.8,0l4.9,32.7l0-32.7c0,0,6.7,0,6.7,0c6.1,0,8.8,4.5,9.6,6         l-0.8-6h6.7l3,22.4l3.1-22.4h18.7v6.7h-6v8.3h6V25.3z M105.6,40.3H93.4V3.5h6.6v30.2h5.7V40.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#980a2a",
    points: "33.9,28.8 37.7,28.8 35.8,13.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "marvelgradient",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1,
    gradientTransform: "rotate(-45)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#de003b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fb4d7f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#marvelgradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#marvelpattern)",
    opacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#marvelpattern2)",
    opacity: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarvel);
export default __webpack_public_path__ + "static/media/marvel.dd7b84f69bc91d1e9b0b95975f016ab7.svg";
export { ForwardRef as ReactComponent };